import React, { useState } from 'react';

interface MaintenanceProps {
  passwordProtection: boolean;
  onUnlock: () => void;
  onValidatePassword: (password: string) => Promise<boolean>;
}

const Maintenance: React.FC<MaintenanceProps> = ({
  passwordProtection,
  onUnlock,
  onValidatePassword,
}) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!passwordProtection) {
      // If no password needed, just unlock
      onUnlock();
      return;
    }

    // Otherwise, call the backend to validate the password
    const success = await onValidatePassword(password);
    if (success) {
      onUnlock();
    } else {
      setError('Incorrect password. Please try again.');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <div className="bg-white rounded-2xl shadow-md p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-center mb-4">Site Under Maintenance</h1>
        <p className="text-gray-600 text-center mb-6">
          We are currently improving our site. Thank you for your patience!
        </p>

        {passwordProtection ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-sm text-gray-500">
              This site is password-protected. Please enter the maintenance password below.
            </p>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter maintenance password"
              className="border border-gray-300 rounded-md px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {error && <p className="text-red-500 text-sm">{error}</p>}
            <button
              type="submit"
              className="bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 w-full"
            >
              Unlock
            </button>
          </form>
        ) : (
          <p className="text-center text-gray-700">
            Please check back later once maintenance is complete.
          </p>
        )}
      </div>
    </div>
  );
};

export default Maintenance;
